<template>
  <v-app class="back">
    <app-bar />
    <v-main>
      <div class="barras">
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
        <div class="barra"></div>
      </div>
      <transition name="slide-fade">
        <router-view />
      </transition>
    </v-main>
    <app-footer/>
  </v-app>
</template>

<script>
import AppBar from "@/components/TheAppbar";
import AppFooter from "@/components/footer";
export default {
  
  components: {
    AppBar,
    AppFooter
  },
};
</script>

<style>
html {
  background: #0e0e0e;
}
.back {
  background: #000000d5 !important;
  position: relative;
  overflow: hidden;
}
.back::after {
  content: "";
  z-index: -1;
  background-image: url("assets/safetaxi_bg.svg") !important;
  background-size: cover !important;
  position: fixed;
  width: 100%;
  height: 100vh;
  filter: grayscale(1) saturate(0) contrast(1);
  animation: animation1 infinite 20s ease-in-out;
}
.barras {
  position: absolute;
  display: none;
  justify-content: space-around;
  top: 0;
  left: 0;
  margin-top: 10px;
  width: 100vw;
  height: 100vh;
}
.barra {
  width: 5px;
  height: 10px;
  /* background: rgb(250, 197, 25); */
  background: #5a5a5a;
  opacity: 0;
  border-radius: 100%;
}

.barra:nth-child(even) {
  animation: animation2 infinite 1.5s ease-out;
}
.barra:nth-child(odd) {
  animation: animation2 infinite 2s ease-in;
}

.barra:nth-child(1) {
  animation-delay: 0.2s;
}

.barra:nth-child(2) {
  animation-delay: 0.8s;
}
.barra:nth-child(3) {
  animation-delay: 0.1s;
}

.barra:nth-child(4) {
  animation-delay: 0.3s;
}
.barra:nth-child(5) {
  animation-delay: 0.2s;
}
.barra:nth-child(6) {
  animation-delay: 0.1s;
}

.barra:nth-child(7) {
  animation-delay: 0.3s;
}
.barra:nth-child(8) {
  animation-delay: 0.2s;
}

@keyframes animation1 {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes animation2 {
  0% {
    transform: translateX(0) translateY(-105vh);
    opacity: 0;
  }
  /* 10% {
    transform: translateX(100vw) translateY(0px) rotateZ(45deg)
  }
  20% {
    transform: translateX(100vw) translateY(20px) rotateZ(45deg)
  }
  30% {
    transform: translateX(100vw) translateY(40px) rotateZ(45deg)
  }*/
  40% {
    background-color: aliceblue;
  }
  50% {
    opacity: 0.1;
  }
  /*60% {
    transform: translateX(100vw) translateY(0px) rotateZ(45deg)
  }
  70% {
    transform: translateX(100vw) translateY(0px) rotateZ(45deg)
  }
  80% {
    transform: translateX(100vw) translateY(0px) rotateZ(45deg)
  }
  90% {
    transform: translateX(100vw) translateY(0px) rotateZ(45deg)
  }*/
  100% {
    transform: translateX(0) translateY(100vh);
    opacity: 0.8;
  }
}
</style>
